var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{ref:"validationRef",attrs:{"rules":_vm.rules,"name":_vm.name},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
var failedRules = ref.failedRules;
return [_vm._t("default",null,null,{ errors: errors, errorTextColour: _vm.errorTextColour, hasError: _vm.hasError, failedRules: failedRules })]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }